import classNames from 'classnames';
import React from 'react';

import Icon from 'components/Icon';
import { IconType } from 'components/Icon/constants';
import BoxInput from 'components/Toolbar/Shared/BoxInput';
import Dropdown from 'components/Toolbar/Shared/Dropdown';
import { BoxPropertySide } from 'const';
import { areBoxPropertiesEqual } from 'utils/immutable';
import { intlGet } from 'utils/intlGet';
import { BorderRadiusProps } from './models';
import styles from './styles.module.scss';

const SideControls = [
  BoxPropertySide.TOP,
  BoxPropertySide.RIGHT,
  BoxPropertySide.LEFT,
  BoxPropertySide.BOTTOM,
];

const editorToolbarPropertyText = 'EditorToolbar.Property';
const TextsByBoxPropertySide: Record<BoxPropertySide, () => string> = {
  [BoxPropertySide.TOP]: () => intlGet(editorToolbarPropertyText, 'TopLeft'),
  [BoxPropertySide.RIGHT]: () => intlGet(editorToolbarPropertyText, 'TopRight'),
  [BoxPropertySide.LEFT]: () => intlGet(editorToolbarPropertyText, 'BottomLeft'),
  [BoxPropertySide.BOTTOM]: () => intlGet(editorToolbarPropertyText, 'BottomRight'),
};

const BorderRadius: React.FunctionComponent<BorderRadiusProps> = (props) => {
  const { borderRadius, toggleBorderRadius, title, dropdownWarningMessage, className, iconTooltipClassName, dataTestId = 'borderRadius' } = props;

  return (
    <Dropdown
      className={classNames(styles.BorderRadiusDropdown, className)}
      dataTestId={`${dataTestId}-dropdown`}
      stopClickPropagation={true}
    >
      <div className={styles.title} data-testid={`${dataTestId}-title`}>
        {intlGet('EditorToolbar', title.toUpperCase())}
        {dropdownWarningMessage && (
          <Icon
            type={IconType.EXCLAMATION_MARK}
            size="sm"
            color="primary"
            hoverTooltipText={dropdownWarningMessage}
            className='ml-1'
            iconTooltipClassName={iconTooltipClassName}
          />
        )}
      </div>
      <BoxInput
        property={borderRadius}
        toggleProperty={toggleBorderRadius}
        max={100}
        isShorthand={areBoxPropertiesEqual(borderRadius)}
        sideControls={SideControls}
        textsByBoxPropertySide={TextsByBoxPropertySide}
        dataTestId={`${dataTestId}-boxInput`}
      />
    </Dropdown>
  );
};

export default BorderRadius;
